export const SERVICE_WORKER_CACHE_VERSION = 'WETAGAPP-03112026-1';
